var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "coupon-container" }, [
    _c("h2", [_vm._v("Ei, você ai, não guarde esse desconto só para você!")]),
    _vm._v(" "),
    _c("h3", [_vm._v("Clica aqui embaixo e compartilha com os amigos.")]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "btn btn-purple",
        attrs: { href: _vm.url, target: "_blank", rel: "noopener noreferrer" }
      },
      [
        _vm._v("\n    Compartilhar cupom\n    "),
        _c("img", {
          staticClass: "ml-10",
          attrs: { src: "\\static\\whatsapp_logo_purple.svg" }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5059a7f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5059a7f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/CouponCard.vue
// module id = null
// module chunks = 